const normalizeLanguage = (language?: string) => (language?.toLowerCase().startsWith('fr') ? 'fr' : 'en');

export const formatDate = (value: string | Date, language?: string) => {
  const date = value instanceof Date ? value : new Date(value);

  return new Intl.DateTimeFormat(normalizeLanguage(language)).format(date);
};

export const formatDateRange = (start: string | Date, end: string | Date, language?: string) => {
  return `${formatDate(start, language)} - ${formatDate(end, language)}`;
};

export const formatPrice = (value: number, language?: string) => {
  const normalized = normalizeLanguage(language);
  const formatter = new Intl.NumberFormat(normalized, {
    minimumFractionDigits: Number.isInteger(value) ? 0 : 2,
    maximumFractionDigits: 2,
  });

  const formattedValue = formatter.format(value);

  return normalized === 'fr' ? `${formattedValue} €` : `€${formattedValue}`;
};